// CONST

let breakpoint = bsBreakpoints.detectBreakpoint();

/**
 * @description Fonction pour gérer la recherche en sticky
 */

const stickySearch = () => {
  const searchBtn =
    document.querySelector("[data-js-header-search-toggle]") || null;
  const banner = `<div class="overlay__search">
                    <button class="overlay__search__close"></button>
                  </div>`;
  const body = document.querySelector("body");
  const highlights = document.querySelector(".highlights__content") || null;
  const HighlightSearch =
    document.querySelector(".highlights .views-exposed-form") || null;
  const notFrontSearch = document.querySelector(".not-front-search") || null;
  const notFrontSearchMultiSite =
    document.querySelector("#block-spe-header-search-form") || null;

  if (searchBtn) {
    searchBtn.addEventListener("click", () => {
      // Open overlay search
      body.classList.add('search');
      body.insertAdjacentHTML("beforeend", banner);
      const searchBtnClose = document.querySelector(".overlay__search__close");
      body.classList.add("overflow-hidden");
      const bannerSearch = document.querySelector(".overlay__search");
      const bannerLogo = document.querySelector(".highlights__content__logo");
      let searchBloc;

      if (notFrontSearchMultiSite) {
        notFrontSearchMultiSite.style.display = "flex";
        searchBloc = notFrontSearchMultiSite;
      } else if (HighlightSearch) {
        searchBloc = HighlightSearch;
      } else if (notFrontSearch) {
        notFrontSearch.style.display = "flex";
        searchBloc = notFrontSearch;
      }
      bannerSearch.appendChild(searchBloc);
      const overlaySearch =
        document.querySelector(".overlay__search form") || null;

      // nav clavier
      const search = document.querySelector(".overlay__search");
      search.querySelector(".form-text").focus();
      search
        .querySelector(".form-text")
        .addEventListener("focusout", function (ev) {
          ev.preventDefault();
          search.querySelector(".overlay__search__close").focus();
        });

      /** -------------------   -------------------  */
      // Close overlay search
      searchBtnClose.addEventListener("click", () => {
        body.classList.remove("overflow-hidden");
        document.querySelector(".overlay__search").remove();
        if (highlights) {
          highlights.insertAdjacentElement("afterbegin", overlaySearch);
          highlights.insertAdjacentElement("afterbegin", bannerLogo);
        }
        overlaySearch.style.top = "50%";
      });
    });
  }
};

window.addEventListener("load", () => {
  stickySearch();
});
